import { Component } from '@angular/core';
import { CountDownFacade } from '@ecosure-suite/common/count-down/data-access-count-down';

@Component({
  selector: 'es-count-down',
  template: `
    You will be logged out in {{ counter$ | async }} seconds!
  `
})
export class CountDownComponent {
  counter$ = this.countDownService.selectedCountDown$;
  constructor(private countDownService: CountDownFacade) {}
}
